import { b as __assign, c as __values } from '../../../tslib.es6-fe064bda.js';

var findUpdateHalfData = function (data, isTopWins) {
    var _a, _b;
    // if there is at least one cashOutInfos this means that the game has half cash out.
    var isCashOutInfos = (_b = (_a = data[0]) === null || _a === void 0 ? void 0 : _a.additionalParams) === null || _b === void 0 ? void 0 : _b.cashOutInfos;
    if (isCashOutInfos) {
        var _loop_1 = function (i) {
            var e_1, _c;
            var halfCurrentBets = data[i].additionalParams.cashOutInfos;
            if (halfCurrentBets === null || halfCurrentBets === void 0 ? void 0 : halfCurrentBets.length) {
                if (halfCurrentBets.length === 1) {
                    if (isTopWins) {
                        data[i] = __assign(__assign({}, data[i]), { odd: halfCurrentBets[0].odd, amount: halfCurrentBets[0].amount, coinAmount: halfCurrentBets[0].coinAmount, winAmount: halfCurrentBets[0].winAmount, winCoinAmount: halfCurrentBets[0].winCoinAmount });
                    }
                    else {
                        data[i] = __assign(__assign({}, data[i]), { amount: halfCurrentBets[0].amount, coinAmount: halfCurrentBets[0].coinAmount, winCoinAmount: 0, winAmount: 0, odd: 0 });
                        data.splice(i + 1, 0, __assign(__assign({}, data[i]), { id: "".concat(data[i].id, "_"), odd: halfCurrentBets[0].odd, amount: halfCurrentBets[0].amount, coinAmount: halfCurrentBets[0].coinAmount, winAmount: halfCurrentBets[0].winAmount, winCoinAmount: halfCurrentBets[0].winCoinAmount }));
                        i++;
                    }
                }
                if (halfCurrentBets.length === 2) {
                    if (isTopWins) {
                        var maxWinAmount_1 = 0;
                        try {
                            for (var halfCurrentBets_1 = (e_1 = void 0, __values(halfCurrentBets)), halfCurrentBets_1_1 = halfCurrentBets_1.next(); !halfCurrentBets_1_1.done; halfCurrentBets_1_1 = halfCurrentBets_1.next()) {
                                var halfCurrentBet = halfCurrentBets_1_1.value;
                                maxWinAmount_1 = Math.max(halfCurrentBet.winAmount, maxWinAmount_1);
                            }
                        }
                        catch (e_1_1) { e_1 = { error: e_1_1 }; }
                        finally {
                            try {
                                if (halfCurrentBets_1_1 && !halfCurrentBets_1_1.done && (_c = halfCurrentBets_1.return)) _c.call(halfCurrentBets_1);
                            }
                            finally { if (e_1) throw e_1.error; }
                        }
                        var halfCurrentMaxWinBet = halfCurrentBets.find(function (item) { return +item.winAmount === +maxWinAmount_1; });
                        data[i] = __assign(__assign({}, data[i]), { odd: halfCurrentMaxWinBet.odd, amount: halfCurrentMaxWinBet.amount, coinAmount: halfCurrentMaxWinBet.coinAmount, winAmount: halfCurrentMaxWinBet.winAmount, winCoinAmount: halfCurrentMaxWinBet.winCoinAmount });
                    }
                    else {
                        data[i] = __assign(__assign({}, data[i]), { amount: halfCurrentBets[0].amount, coinAmount: halfCurrentBets[0].coinAmount, winAmount: halfCurrentBets[0].winAmount, odd: halfCurrentBets[0].odd, winCoinAmount: halfCurrentBets[0].winCoinAmount });
                        data.splice(i + 1, 0, __assign(__assign({}, data[i]), { id: "".concat(data[i].id, "_"), amount: halfCurrentBets[1].amount, winAmount: halfCurrentBets[1].winAmount, coinAmount: halfCurrentBets[1].coinAmount, odd: halfCurrentBets[1].odd, winCoinAmount: halfCurrentBets[1].winCoinAmount }));
                        i++;
                    }
                }
            }
            out_i_1 = i;
        };
        var out_i_1;
        for (var i = 0; i < data.length; i++) {
            _loop_1(i);
            i = out_i_1;
        }
    }
};

export { findUpdateHalfData };
